import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba04918"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-9 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-5 fs-15 fs-md-16 fs-lg-18" }, " Ajustes razonables del PIAR "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph fs-13 fs-md-14" }, " Registra y consulta los ajustes que apoyan el proceso académico del estudiante por asignatura, barrera y competencia. ")
], -1))
const _hoisted_7 = { class: "mt-10 mt-md-0 d-flex flex-wrap gap-2" }
const _hoisted_8 = { class: "badge bg-primary text-white fs-11" }
const _hoisted_9 = { class: "badge bg-success text-white fs-11" }
const _hoisted_10 = { class: "mb-20 mb-md-25" }
const _hoisted_11 = { class: "row g-3" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Asignatura", -1))
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Tipo de barrera", -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Objetivo estándar", -1))
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Objetivo ajustado", -1))
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Descripción de la barrera", -1))
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Ajustes razonables", -1))
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Competencia asociada", -1))
const _hoisted_26 = { class: "col-md-3 d-flex align-items-center mt-2" }
const _hoisted_27 = { class: "col-12 mt-2" }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Limpiar formulario", -1))
const _hoisted_30 = { class: "col-lg-5 col-xl-3" }
const _hoisted_31 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box" }
const _hoisted_32 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_33 = { class: "profile-info d-sm-flex align-items-center" }
const _hoisted_34 = {
  class: "position-relative w-100",
  style: {"max-width":"260px"}
}
const _hoisted_35 = { class: "ratio ratio-1x1 rounded-circle overflow-hidden shadow-sm" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1))
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_39 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_41 = { class: "title mt-12 mt-sm-0" }
const _hoisted_42 = { class: "d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8" }
const _hoisted_43 = { class: "d-block fw-bold text-primary" }
const _hoisted_44 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_45 = { class: "position-relative" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-copy" })
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Año académico", -1))
const _hoisted_48 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_49 = { class: "position-relative" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-status" })
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Ajustes activos", -1))
const _hoisted_52 = { class: "badge text-outline-info" }
const _hoisted_53 = { class: "position-relative" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock" })
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, " Última actualización de ajustes ", -1))
const _hoisted_56 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-xl-12" }
const _hoisted_59 = { class: "card mb-25 border-0 rounded-0 bg-transparent letter-spacing course-details-card" }
const _hoisted_60 = { class: "card-body p-0" }
const _hoisted_61 = { class: "mb-12 mb-md-15 d-flex justify-content-between align-items-center px-15 px-sm-20 px-md-25 px-lg-30 pt-10" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary fw-black fs-20 fs-md-22 fs-lg-24" }, " Ajustes registrados ", -1))
const _hoisted_63 = {
  key: 0,
  class: "text-muted fs-12"
}
const _hoisted_64 = {
  class: "accordion piar-timeline px-15 px-sm-20 px-md-25 px-lg-30 pb-15",
  id: "piarAdjustmentsAccordion"
}
const _hoisted_65 = {
  key: 0,
  class: "text-center text-success my-3"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Cargando ajustes...", -1))
const _hoisted_67 = {
  key: 1,
  class: "text-muted fs-13"
}
const _hoisted_68 = ["data-bs-target", "aria-controls", "aria-expanded"]
const _hoisted_69 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_70 = { class: "d-flex align-items-center" }
const _hoisted_71 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "adjustment-icon me-10" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit fs-13" })
], -1))
const _hoisted_73 = { class: "fw-bold" }
const _hoisted_74 = { class: "text-muted d-block" }
const _hoisted_75 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled gap-3" }
const _hoisted_76 = { class: "position-relative fw-medium fs-12 text-muted" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-5" }, null, -1))
const _hoisted_78 = { class: "position-relative fw-medium fs-12 text-muted" }
const _hoisted_79 = ["id"]
const _hoisted_80 = { class: "accordion-body" }
const _hoisted_81 = { class: "row g-3" }
const _hoisted_82 = { class: "col-12" }
const _hoisted_83 = { class: "bg-gray p-10 rounded-1 h-100" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-14 fs-lg-15 fw-bold mb-1" }, " Objetivo estándar ", -1))
const _hoisted_85 = { class: "mb-0 text-paragraph fs-13" }
const _hoisted_86 = { class: "col-12" }
const _hoisted_87 = { class: "bg-gray p-10 rounded-1 h-100" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-14 fs-lg-15 fw-bold mb-1" }, " Objetivo ajustado ", -1))
const _hoisted_89 = { class: "mb-0 text-paragraph fs-13" }
const _hoisted_90 = { class: "col-12" }
const _hoisted_91 = { class: "bg-gray p-10 rounded-1 h-100" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-14 fs-lg-15 fw-bold mb-1" }, " Barrera ", -1))
const _hoisted_93 = { class: "mb-0 text-paragraph fs-13" }
const _hoisted_94 = { class: "col-12" }
const _hoisted_95 = { class: "bg-gray p-10 rounded-1 h-100" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-14 fs-lg-15 fw-bold mb-1" }, " Ajustes razonables ", -1))
const _hoisted_97 = { class: "mb-0 text-paragraph fs-13" }
const _hoisted_98 = { class: "col-12" }
const _hoisted_99 = { class: "bg-gray p-10 rounded-1" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black-emphasis fs-md-14 fs-lg-15 fw-bold mb-1" }, " Competencia asociada ", -1))
const _hoisted_101 = { class: "mb-0 text-paragraph fs-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_badge = _resolveComponent("b-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.adjustments.length) + " ajustes registrados ", 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.activeAdjustmentsCount) + " activos ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_b_form, {
                onSubmit: _withModifiers(_ctx.saveNewAdjustment, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_SearchSelect, {
                        modelValue: _ctx.newAdjustment.SubjectId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newAdjustment.SubjectId) = $event)),
                        loading: _ctx.loadingSubjects,
                        options: _ctx.subjects.map((s) => ({
                                        value: s.Id,
                                        text: `${s.Code} - ${s.Name}`,
                                    })),
                        placeholder: "Seleccione la asignatura"
                      }, null, 8, ["modelValue", "loading", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_b_form_select, {
                        modelValue: _ctx.newAdjustment.BarrierType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAdjustment.BarrierType) = $event)),
                        size: "sm",
                        options: _ctx.barrierTypeOptions
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_b_form_textarea, {
                        modelValue: _ctx.newAdjustment.ObjectiveStandard,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAdjustment.ObjectiveStandard) = $event)),
                        rows: "3",
                        size: "sm",
                        placeholder: "Objetivo estándar del curso o asignatura"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_b_form_textarea, {
                        modelValue: _ctx.newAdjustment.ObjectiveAdjusted,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newAdjustment.ObjectiveAdjusted) = $event)),
                        rows: "3",
                        size: "sm",
                        placeholder: "Objetivo ajustado según las necesidades del estudiante"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_b_form_textarea, {
                        modelValue: _ctx.newAdjustment.BarrierDescription,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newAdjustment.BarrierDescription) = $event)),
                        rows: "3",
                        size: "sm",
                        placeholder: "Describe la barrera que dificulta el aprendizaje"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_b_form_textarea, {
                        modelValue: _ctx.newAdjustment.ReasonableAdjustment,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newAdjustment.ReasonableAdjustment) = $event)),
                        rows: "3",
                        size: "sm",
                        placeholder: "Estrategias, apoyos o adaptaciones que se implementarán"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_b_form_textarea, {
                        modelValue: _ctx.newAdjustment.Competence,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newAdjustment.Competence) = $event)),
                        rows: "2",
                        size: "sm",
                        placeholder: "Competencia o logro frente al cual se aplica el ajuste"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: _ctx.newAdjustment.Status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newAdjustment.Status) = $event)),
                        value: 1,
                        "unchecked-value": 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ajuste activo ")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_b_button, {
                          class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                          type: "submit",
                          disabled: _ctx.savingNew
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.savingNew ? "Guardando..." : "Guardar ajuste"), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_b_button, {
                          class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
                          type: "button",
                          onClick: _ctx.resetNewForm
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: _ctx.previewUrl,
                    alt: "Foto estudiante",
                    class: "w-100 h-100 object-fit-cover d-block"
                  }, null, 8, _hoisted_36)
                ])
              ])
            ]),
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h6", _hoisted_39, _toDisplayString(_ctx.header.StudentName || "Estudiante sin nombre"), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.header.CourseGroupName || "Grupo sin asignar"), 1)
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_44, [
              _createElementVNode("li", _hoisted_45, [
                _hoisted_46,
                _hoisted_47,
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.header.AcademicYearName || "Sin año definido"), 1)
              ]),
              _createElementVNode("li", _hoisted_49, [
                _hoisted_50,
                _hoisted_51,
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.activeAdjustmentsCount), 1)
              ]),
              _createElementVNode("li", _hoisted_53, [
                _hoisted_54,
                _hoisted_55,
                _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.lastUpdateDisplay), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              (_ctx.adjustments.length)
                ? (_openBlock(), _createElementBlock("small", _hoisted_63, _toDisplayString(_ctx.adjustments.length) + " ajuste(s) · " + _toDisplayString(_ctx.activeAdjustmentsCount) + " activo(s) ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_64, [
              (_ctx.loadingAdjustments)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createVNode(_component_b_spinner, { class: "align-middle" }),
                    _hoisted_66
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.loadingAdjustments && !_ctx.adjustments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Aún no se han registrado ajustes para este PIAR. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adj, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: adj.Id,
                  class: "accordion-item border-0 piar-timeline-item"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0", { collapsed: index !== 0 }]),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#piarAdjustmentCollapse${adj.Id}`,
                    "aria-controls": `piarAdjustmentCollapse${adj.Id}`,
                    "aria-expanded": index === 0 ? 'true' : 'false'
                  }, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(index + 1), 1),
                        _hoisted_72,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_73, _toDisplayString(adj.SubjectName || "Asignatura sin nombre"), 1),
                          _createElementVNode("small", _hoisted_74, _toDisplayString(_ctx.formatBarrierType(adj.BarrierType)) + " · " + _toDisplayString(adj.CreatedDate
                                                        ? new Date(adj.CreatedDate).toLocaleDateString()
                                                        : "Sin fecha"), 1)
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_75, [
                        _createElementVNode("li", _hoisted_76, [
                          _hoisted_77,
                          _createTextVNode(" " + _toDisplayString(adj.Competence ? "Con competencia" : "Sin competencia"), 1)
                        ]),
                        _createElementVNode("li", _hoisted_78, [
                          _createVNode(_component_b_badge, {
                            variant: adj.Status ? 'success' : 'secondary',
                            class: "px-2 py-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(adj.Status ? "Activo" : "Inactivo"), 1)
                            ]),
                            _: 2
                          }, 1032, ["variant"])
                        ])
                      ])
                    ])
                  ], 10, _hoisted_68),
                  _createElementVNode("div", {
                    class: _normalizeClass(["accordion-collapse collapse", { show: index === 0 }]),
                    id: `piarAdjustmentCollapse${adj.Id}`,
                    "data-bs-parent": "#piarAdjustmentsAccordion"
                  }, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _createElementVNode("div", _hoisted_83, [
                            _hoisted_84,
                            _createElementVNode("p", _hoisted_85, _toDisplayString(adj.ObjectiveStandard || "Sin información"), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _hoisted_88,
                            _createElementVNode("p", _hoisted_89, _toDisplayString(adj.ObjectiveAdjusted || "Sin información"), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _hoisted_92,
                            _createElementVNode("p", _hoisted_93, _toDisplayString(adj.BarrierDescription || "Sin descripción"), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _hoisted_96,
                            _createElementVNode("p", _hoisted_97, _toDisplayString(adj.ReasonableAdjustment || "Sin descripción"), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _hoisted_100,
                            _createElementVNode("p", _hoisted_101, _toDisplayString(adj.Competence || "Sin competencia asociada"), 1)
                          ])
                        ])
                      ])
                    ])
                  ], 10, _hoisted_79)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}